import { ProductFulfillmentCategories } from "../../../services/constants.js";
const getProductFullfillmentTexts = (fullfillmentCategory, translationsConfig) => {
  const { translations } = translationsConfig || {};
  if (!fullfillmentCategory || !translations) return null;
  const fulfillmentTexts = {
    label: translations.onlinepricelabel,
    tooltipTitle: translations.onlinepricelabel,
    tooltip: translations.onlinepricetooltiptext,
    iconAriaLabel: translations.onlinepriceiconarialabel
  };
  if (fullfillmentCategory === ProductFulfillmentCategories.WAREHOUSE) {
    fulfillmentTexts.label = translations.warehousepricelabel;
    fulfillmentTexts.tooltip = translations.warehousepricetooltiptext;
    fulfillmentTexts.tooltipTitle = translations.warehousepricelabel;
    fulfillmentTexts.iconAriaLabel = translations.warehousepriceiconarialabel;
  }
  return fulfillmentTexts;
};
export {
  getProductFullfillmentTexts
};
